/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Chat {

    @Serenity.Decorators.registerClass()
    export class ChatlinkcontactsGrid extends NoboxEntityGrid<ChatlinkcontactsRow, any> {
        protected getColumnsKey() { return ChatlinkcontactsColumns.columnsKey; }
        protected getDialogType() { return ChatlinkcontactsDialog; }
        protected getIdProperty() { return ChatlinkcontactsRow.idProperty; }
        protected getInsertPermission() { return ChatlinkcontactsRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatlinkcontactsRow.localTextPrefix; }
        protected getService() { return ChatlinkcontactsService.baseUrl; }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
        constructor(container: JQuery) {
            super(container);
            var q = Q.parseQueryString();
            if (q["fd"] && q["ld"]) {
                var categoryDt = this.findQuickFilter(CustomDateFilter,
                    ChatlinkcontactsRow.Fields.In);
                categoryDt.set_value(q["fd"]);
                categoryDt.end_set_value(q["ld"]);
            }
            if (q["channel"]) {
                this.findQuickFilter(Serenity.ServiceLookupEditor, ChatlinkcontactsRow.Fields.ChId).value = q["channel"];
            }
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            return buttons;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];

            Q.first(columns, x => x.field == ChatlinkcontactsRow.Fields.ChId).format =
                ctx => `<a href="javascript:;" class="channel-link" data-id="${ctx.item.ChId}">${Q.htmlEncode(listChannel[ctx.value]== undefined ? "" : listChannel[ctx.value].Nm)}</a>`;
            //Q.first(columns, x => x.field == ChatlinkcontactsRow.Fields.Ch).format =
            //    ctx => `<a href="javascript:;" class="channel-link" data-id="${ctx.item.ChId}">${Q.htmlEncode(ctx.value)}</a>`;
            //Q.first(columns, x => x.field == ChatlinkcontactsRow.Fields.Acc).format =
            //    ctx => `<a href="javascript:;" class="account-link" data-id="${ctx.item.AccId}">${Q.htmlEncode(ctx.value)}</a>`;

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("channel-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by channel");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatlinkcontactsRow.Fields.ChId).set_value(target.attr("data-id"));
                this.refresh();
            }
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == ChatlinkcontactsRow.Fields.In);
            filter1.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    request.Criteria = null;
                    h.handled = true;
                }
            };
            return flt;
        }
    }
}